import * as React from 'react';
import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@newcore/ui/card';
import { FontWeights } from '@newcore/ui/enums/font-weights';
import { DisplaySizes } from '@newcore/ui/enums/typography-display-sizes';
import { Display } from '@newcore/ui/typography';
import { OnboardingPageLayout } from './onboarding-page-layout';

export const ONBOARDING_DEFAULT_TITLE = 'Account Setup';

interface OnboardingStatusCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export function OnboardingStatusCard({
  title,
  description,
  children,
}: OnboardingStatusCardProps): React.ReactElement {
  return (
    <OnboardingPageLayout>
      <CardHeader className='space-y-1'>
        <Display asChild size={DisplaySizes.XS} weight={FontWeights.BOLD}>
          <CardTitle className='text-center'>{title}</CardTitle>
        </Display>
        <CardDescription className='text-center'>{description}</CardDescription>
      </CardHeader>
      <CardContent className='flex flex-col items-center py-6'>
        <div className='flex flex-col items-center space-y-4'>{children}</div>
      </CardContent>
    </OnboardingPageLayout>
  );
}
